
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { LanguageItem } from "@/plugins/cacheProvider";

interface LanguageTableItem extends LanguageItem {
  Enabled: boolean;
}

@Component
export default class PageLanguageComponent extends Vue {  
  isLoading = false;
  newLanguageCode = "";
  newLanguageName = "";
  items: LanguageTableItem[] = [];
  get enabledLanguagesCount(): number {
    return this.items.filter((item) => item.Enabled).length;
  }
  async created() {
    await this.loadLanguages();
  }
  async loadLanguages() {
    this.isLoading = true;
    try {
      const languages = await this.$cacheProvider.getLanguageItemsAsync();
      this.items = languages.map((language) => ({
        ...language,
        Enabled: !language.IsHide
      }));
    } catch (error) {
      this.items = [];
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
  async setLanguageEnabled(item: LanguageTableItem, enabled: boolean) {
    if (!enabled && item.Enabled && this.enabledLanguagesCount === 1) {
      return;
    }
    const previousEnabled = item.Enabled;
    item.Enabled = enabled;
    item.IsHide = !enabled;
    try {
      await this.$cacheProvider.saveLanguageAsync(item);
    } catch (error) {
      item.Enabled = previousEnabled;
      item.IsHide = !previousEnabled;
      this.$notification.error(error);
    }
  }
  async addLanguage() {
    const langCode = (this.newLanguageCode || "").trim().toLowerCase();
    if (!/^[a-z]{2,3}(?:-[a-z0-9]{2,8})?$/.test(langCode)) {
      this.$notification.error(
        "Введите новый код языка: 2-3 буквы, при необходимости с регионом, например pt-br"
      );
      return;
    }
    if (this.items.some((item) => item.Code.toLowerCase() === langCode)) {
      this.$notification.error("Такой язык уже есть в списке");
      return;
    }
    this.isLoading = true;
    try {
      await this.$cacheProvider.saveLanguageAsync({
        Id: null,
        Code: langCode,
        Name: (this.newLanguageName || langCode).trim(),
        IsHide: false
      });
      await this.loadLanguages();
      this.newLanguageCode = "";
      this.newLanguageName = "";
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
  async removeLanguage(item: LanguageTableItem) {
    if (this.items.length === 1) {
      this.$notification.error("Нельзя удалить последний язык");
      return;
    }
    if (!item.Id) {
      this.$notification.error("Язык без серверного id нельзя удалить через новый API");
      return;
    }
    const confirmed = await this.$dialog.confirm(
      `Удалить язык ${item.Code} из списка? Сохраненные переводы удалены не будут.`
    );
    if (!confirmed) {
      return;
    }
    this.isLoading = true;
    try {
      await this.$cacheProvider.deleteLanguageAsync(item.Id);
      this.items = this.items.filter((language) => language.Id !== item.Id);
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
}
